import { DATA_FR } from '../data/fr';

export const TerminalWidget = ({ data }: { data: typeof DATA_FR }) => (
  <div className="bg-[#1e1e1e] rounded-[24px] overflow-hidden shadow-elevation-2">
    <div className="flex items-center gap-2 px-5 py-3 bg-[#2d2d2d] border-b border-[#3e3e3e]">
      <div className="w-3 h-3 rounded-full bg-[#ff5f56]" />
      <div className="w-3 h-3 rounded-full bg-[#ffbd2e]" />
      <div className="w-3 h-3 rounded-full bg-[#27ca40]" />
      <span className="ml-3 text-xs text-[#888] font-mono opacity-60">pierre@portfolio ~ zsh</span>
    </div>
    <div className="p-6 font-mono text-sm leading-relaxed">
      <div className="flex gap-2">
        <span className="text-[#f778ba]">➜</span>
        <span className="text-[#7ee787]">cat</span>
        <span className="text-[#e1e3e5]">profile.json</span>
      </div>
      <pre className="text-[#a9b7c6] mt-3 overflow-x-auto custom-scrollbar">
{`{
  "name": "${data.personal.name}",
  "role": "${data.personal.role}",
  "status": "${data.personal.availability.toLowerCase().replace(/\s/g, '_')}",
  "skills": [
    "kubernetes",
    "python",
    "go",
    "terraform",
    "gitlab-ci"
  ]
}`}
      </pre>
      <div className="flex gap-2 mt-3">
        <span className="text-[#f778ba]">➜</span>
        <span className="animate-pulse bg-[#a9b7c6] w-2 h-5 block" />
      </div>
    </div>
  </div>
);
